import { useState, useEffect } from 'react';
import { getFeatureListByDomain } from '../api/theme_settings';
import theme_config from '../../config';

const useFeatureList = ({ withRefetch = false } = {}) => {
  const [featureList, setFeatureList] = useState(null);

  const fetchFeatureList = async () => {
    const list  = await import(`../assets/${theme_config.feature_list}`);

    setFeatureList(list);
  };

  useEffect(() => {
    fetchFeatureList();
  }, []);

  if (withRefetch) {
    return { featureList, refetchFeatureList: fetchFeatureList };
  }

  return featureList;
};

export default useFeatureList;
